import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApi, fmtDate, fmtCost } from "@/lib/api";
import { PageHeader, Card, Sel } from "@/components/common";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export const MODE_LABEL = { draft: "brouillon", test: "test", published: "publiée" };
export const CHANNELS = [{ value: "all", label: "Tous les canaux" }, { value: "studio", label: "Studio" }, { value: "telephone_simule", label: "Téléphone (simulé)" }, { value: "regression", label: "Régression" }];

export default function Conversations() {
  const [agent, setAgent] = useState("all");
  const [channel, setChannel] = useState("all");
  const [days, setDays] = useState("30");
  const [empty, setEmpty] = useState(false);
  const q = `/conversations?days=${days}&include_empty=${empty}${agent !== "all" ? `&agent_id=${agent}` : ""}${channel !== "all" ? `&channel=${channel}` : ""}`;
  const { data } = useApi(q, [q]);
  const { data: agents } = useApi("/agents");
  const nav = useNavigate();
  return (
    <div>
      <PageHeader title="Historique des conversations" subtitle="Messages, agents et versions, outils, sources, modèles, latence, coûts et évaluations." />
      <div className="flex gap-2 mb-4 flex-wrap">
        <Sel className="w-56" testid="history-agent-filter" value={agent} onChange={setAgent} options={[{ value: "all", label: "Tous les agents" }, ...(agents || []).map((a) => ({ value: a.id, label: a.name }))]} />
        <Sel className="w-48" testid="history-channel-filter" value={channel} onChange={setChannel} options={CHANNELS} />
        <label className="flex items-center gap-2 text-sm text-muted-foreground"><input type="checkbox" checked={empty} onChange={(e) => setEmpty(e.target.checked)} data-testid="history-include-empty" />Sessions vides</label>
        <Sel className="w-40" value={days} onChange={setDays} options={[["1", "24 h"], ["7", "7 jours"], ["30", "30 jours"], ["365", "1 an"]].map(([value, label]) => ({ value, label }))} />
      </div>
      <Card className="p-0 overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead>Date</TableHead><TableHead>Identifiant</TableHead><TableHead>Canal</TableHead><TableHead>Premier message</TableHead><TableHead>Agents / versions</TableHead><TableHead>Tours</TableHead><TableHead>Coût</TableHead><TableHead>Éval.</TableHead></TableRow></TableHeader>
          <TableBody>
            {(data || []).map((c) => (
              <TableRow key={c.id} className="cursor-pointer" onClick={() => nav(`/historique/${c.id}`)} data-testid={`conv-row-${c.id}`}>
                <TableCell className="text-xs whitespace-nowrap">{fmtDate(c.started_at)}</TableCell>
                <TableCell className="mono text-xs">{c.id.slice(0, 8)}</TableCell>
                <TableCell className="text-xs">{c.channel}{c.channels?.includes("voice") ? " · voix" : ""} · {MODE_LABEL[c.mode] || c.mode}</TableCell>
                <TableCell className="text-xs max-w-xs truncate">{c.first_message}</TableCell>
                <TableCell className="text-xs">{(c.agents_used || []).map((a) => `${a.name} (${a.version})`).join(", ")}</TableCell>
                <TableCell>{c.totals?.turns || 0}</TableCell>
                <TableCell className="text-xs">{fmtCost(c.totals?.cost_eur)}</TableCell>
                <TableCell>{c.evaluation_count}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
